import { render, staticRenderFns } from "./WeeklyWorkPohangReply.vue?vue&type=template&id=05ff7f8a"
import script from "./WeeklyWorkPohangReply.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkPohangReply.vue?vue&type=script&lang=js"
import style0 from "./WeeklyWorkPohangReply.vue?vue&type=style&index=0&id=05ff7f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports